export default [{
	titulo: 'Publicidades',
	icone: 'menu-icon fa fa-caret-right',
	url: '/sistema/publicidades',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]